export default __webpack_public_path__ + "052f916.png";